function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "love"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m12.001 20.818c-.803 0-1.556-.311-2.121-.875l-6.054-6.055c-2.434-2.449-2.434-6.431-.002-8.878 1.178-1.178 2.755-1.826 4.443-1.826 1.37 0 2.667.428 3.735 1.215 1.073-.791 2.369-1.217 3.732-1.217 1.679 0 3.255.646 4.439 1.824 1.179 1.176 1.827 2.754 1.827 4.443 0 1.688-.647 3.266-1.824 4.439l-6.053 6.055c-.565.565-1.319.875-2.122.875zm-3.734-15.634c-1.154 0-2.229.439-3.027 1.238-1.657 1.668-1.657 4.385.002 6.055l6.051 6.053c.375.373 1.04.373 1.415-.002l6.053-6.053c.8-.797 1.239-1.873 1.239-3.026 0-1.154-.439-2.23-1.238-3.027-.805-.799-1.881-1.24-3.027-1.24s-2.222.439-3.028 1.242c-.391.389-1.022.389-1.413-.002-.798-.799-1.873-1.238-3.027-1.238z"
})));

var Svg060Love = function Svg060Love(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg060Love, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/060-love.03f1fffd.svg";
export { ForwardRef as ReactComponent };